import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import DynamicFormPage from "../../components/DynamicFormPage";
import { getStoneVariationDetails } from "../../helpers/http_stone_variations_requests";
import { useQuery } from "@tanstack/react-query";
import { centsToReais } from "../../utils/functions";

export default function StoneVariationDetails() {

    const navigate = useNavigate();

    const { id } = useParams();

    const { data, isFetching } = useQuery({ queryKey: ['getStoneVariationDetails', id], queryFn: () => getStoneVariationDetails(id), staleTime: 1000 * 5 });

    const { data: dataList } = data?.data ?? {};

    const formFieldList = [
        {
            title: "Informações da Pedra",
            fields: [
                {
                    name: "name",
                    label: "Nome",
                    type: "text",
                    required: true,
                },
                {
                    name: "size",
                    label: "Tamanho",
                    type: "number",
                    end_adornment: "mm",
                    required: true
                },
                {
                    name: "price",
                    label: "Preço",
                    type: "text",
                    mask: "currency",
                    required: true
                },
                {
                    name: "description",
                    label: "Descrição",
                    type: "text",
                    multiline: true,
                    rows: 5,
                    fullWidth: true,
                    required: true,
                },
            ]
        },
    ];

    return <DynamicFormPage isLoading={isFetching} details initialData={dataList ? { ...dataList, price: centsToReais(dataList.price) } : dataList} title={"Variação - Detalhes"} formFieldList={formFieldList} onCancel={() => navigate(-1)} />;
};